import { useQueryParams } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function StatusFilter(props: { isLoading: boolean }) {
  const { getParamsAsArray, setParam } = useQueryParams();
  const { t } = useTranslation();

  const paramKey = "archived";
  const statusList = [
    {
      id: "ACTIVE",
      name: t("Active"),
    },
    {
      id: "ARCHIVED",
      name: t("Archived"),
    },
  ];

  return (
    <Picker
      isLoading={props.isLoading}
      showActionBar
      selectedKeys={
        getParamsAsArray(paramKey).length > 0
          ? getParamsAsArray(paramKey)
          : ["ACTIVE"]
      }
      onSelectionChange={(keys) =>
        setParam(paramKey, Array.from(keys).map(String), true)
      }
      label={t("Status")}
      items={statusList}
      selectionMode="multiple"
      testID="status-type-filter"
    />
  );
}
